import { timeOut } from "@configs";
import { useCallback, useContext } from "react";
import { NotiContext } from "./hooks";

export const useNotify = () => {
  const api = useContext(NotiContext);
  const success = useCallback(
    (msg: string) => {
      api.success({ message: msg, duration: timeOut });
    },
    [""]
  );
  const error = useCallback(
    (msg: string) => {
      api.error({ message: msg, duration: timeOut });
    },
    [""]
  );
  const warning = useCallback(
    (msg: string) => {
      api.warning({ message: msg, duration: timeOut });
    },
    [""]
  );
  const info = useCallback(
    (msg: string) => {
      api.info({ message: msg, duration: timeOut });
    },
    [""]
  );
  return {
    success,
    error,
    warning,
    info,
  };
};
